<template>
  <div class="locale-switcher">
  <v-menu v-if="$store.getters.isAuthenticated" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="secondary" v-bind="attrs" v-on="on">
            {{ $i18n.locale }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item v-for="locale in locales" :key="locale.code">
          <v-btn text block @click="changeLocale(locale.code)">
            {{ locale.name }}
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import { getSupportedLocales } from '@/util/i18n/supported-locales'
  import { cookies } from '@/util/cookies'

  export default {
    data: () => ({ locales: getSupportedLocales() }),
    methods: {
      changeLocale (code) {
        cookies.set('locale', code)
        this.$i18n.locale = code
      },
    },
  }
</script>

<style scoped>
.locale-switcher {
  color: white;
}
</style>
